import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserModal } from '../user.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../../../shared/services/util.service';
import { ApiService } from '../../../shared/services/api.service';
import { PATTERNS } from '../../../shared/constants/patterns.constants';
import { StaticDataService } from '../../../shared/services/static-data.service';

@Component({
  standalone: false,
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrl: './new-user.component.scss'
})
export class NewUserComponent {

  @Input() newUser: any;
  @Output() onSave = new EventEmitter<boolean>();
  errorMessage = '';
  depts: any;
  roles = [];
  pattern = PATTERNS;
  modalTitle = 'New User';

  constructor(private activeModal: NgbActiveModal,
    private _util: UtilService,
    private _apiService: ApiService,
    private _statisData: StaticDataService
  ) { }

  ngOnInit() {
    const vm = this;
    this.depts = this._statisData.getDepts();
    if (vm.newUser && vm.newUser._id) {
      vm.newUser = vm.newUser;
      this.roles = this.depts.find((d: any) => d && d.dept === this.newUser.department).roles;
      this.modalTitle = 'Edit User';
    } else {
      vm.newUser = new UserModal();
    }
  }

  onDepartmentChange() {
    this.newUser.role = '';
    this.roles = this.depts.find((d: any) => d && d.dept === this.newUser.department).roles;
  }

  onClose() {
    const vm = this;
    vm.activeModal.close(true);
  }

  onSubmit() {
    const vm = this;
    vm.errorMessage = '';
    const apiUrl = vm.newUser._id ? '/users/v1/update-user' : '/users/v1/new-user';
    vm._apiService.postData(apiUrl, vm.newUser).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          vm.activeModal.close(true);
          vm.onSave.emit();
          vm._util.navigate('/app/users');
        } else {
          vm.errorMessage = res.message || 'EmailID already exist please use another one';
        }
      },
      error: (err: any) => {
        vm.errorMessage = (err.error && err.error.message) || err.message || 'An error occurred while creating the user. Please try again.';
      }
    });
  }

}
